var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.933a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8m0 6c1.98 0 4.067.974 4.067 1.4v.734H3.933v-.734c0-.426 2.087-1.4 4.067-1.4m0-7.266A2.666 2.666 0 1 0 8 8a2.666 2.666 0 1 0 0-5.333zm0 6c-1.78 0-5.333.893-5.333 2.666v1.334c0 .366.3.666.666.666h9.334c.366 0 .666-.3.666-.666v-1.334C13.333 9.56 9.78 8.667 8 8.667z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.84034e16234aa83541129925fe9a3472.svg";
export { ForwardRef as ReactComponent };